import { useTranslation } from 'react-i18next'
import { Outlet, useLocation } from 'react-router'
import { KeyRound } from 'lucide-react'
import './AuthLayout.scss'

export default function AuthLayout() {
  const { t } = useTranslation()
  const location = useLocation()

  // per-page brand panel copy (design 01/09/10/11)
  const taglines: Record<string, { title: string; sub: string }> = {
    '/login': { title: 'brand.tagline', sub: 'brand.taglineSub' },
    '/register': { title: 'auth.registerTagline', sub: 'auth.registerSub' },
    '/forgot': { title: 'auth.forgotTagline', sub: 'auth.forgotSub' },
    '/reset': { title: 'auth.resetTagline', sub: 'auth.resetSub' },
  }
  const tagline = taglines[location.pathname] ?? taglines['/login']

  return (
    <div className="auth-page">
      <aside className="brand-panel">
        <div className="decor decor-a" />
        <div className="decor decor-b" />
        <div className="decor-rule" />
        <div className="logo-row">
          <div className="mark">
            <KeyRound size={15} strokeWidth={2} />
          </div>
          <span className="wordmark">{t('brand.name')}</span>
        </div>
        <div className="spacer" />
        <div className="tagline-box">
          <p className="tagline">{t(tagline.title)}</p>
          <p className="tagline-sub">{t(tagline.sub)}</p>
        </div>
      </aside>
      <main className="form-area">
        <div className="form-column">
          <Outlet />
        </div>
        <p className="copyright">{t('brand.copyright')}</p>
      </main>
    </div>
  )
}
